export default __webpack_public_path__ + "c4bd3ad2b38a000d8e00e52728a03a5c.png";